import { FAMILY_KEY, PROGRAM_KEY } from "../../constants/common"

const ALL = 'All'
const SUBMITTEDFORAPS = 'Submitted for APS Review'
const APPROVEDBYAPS = 'Approved by APS'
const REJECTEDBYAPS = 'Rejected by APS'
const SUBMITTEDFORENPHASE = 'Submitted for Enphase Review'
const APPROVEDBYENPHASE = 'Approved by Enphase'
const REJECTEDBYENPHASE = 'Rejected by Enphase'

const SUBMITTEDFORPSEGREVIEW = 'Submitted for PSEG Review'
const APPROVEDBYPSEG = 'Approved by PSEG'
const REJECTEDBYPSEG = 'Rejected by PSEG'

const SUBMITTEDFORUTILITYREVIEW = 'Submitted for Utility Review'
const APPROVEDBYUTILITY = 'Approved by Utility'
const REJECTEDBYUTILITY = 'Rejected by Utility'

const applicationStatus = {
  'Application_Submitted': ['Submitted for APS Review', '#F0D852', 2],
  'Application_Approved': ['Approved by APS', '#4ED01F', 3],
  'Application_Rejected': ['Rejected by APS', '#FA2E2E', 2],
  'Site_Submitted': ['Submitted for Enphase Review', '#F0D852', 5],
  'Site_Approved': ['Approved by Enphase', '#4ED01F', 6],
  'Site_Rejected': ['Rejected by Enphase', '#FA2E2E', 5],
}

const tableApplicationStatus = {
  [PROGRAM_KEY.APS_RBP]: {
    'Application_Submitted': ['Submitted for APS Review', '#F0D852', 2, 'Application submitted for APS Review'],
    'Application_Approved': ['Approved by APS', '#4ED01F', 3, 'Application approved by APS'],
    'Application_Rejected': ['Rejected by APS', '#FA2E2E', 2, 'Application rejected by APS'],
    'Site_Submitted': ['Submitted for Enphase Review', '#F0D852', 5, 'Application submitted for Enphase Review'],
    'Site_Approved': ['Approved by Enphase', '#4ED01F', 6, 'Application approved by Enphase'],
    'Site_Rejected': ['Rejected by Enphase', '#FA2E2E', 5, 'Application rejected by Enphase'],
  },
  [PROGRAM_KEY.PSEG_LI]: {
    'Application_Submitted': ['Submitted for Enphase Review', '#F0D852', 2, 'Application submitted for Enphase Review'],
    'Application_Approved': ['Submitted for PSEG Review', '#F0D852', 4, 'Application submitted for PSEG Review'],
    'Application_Rejected': ['Rejected by Enphase', '#FA2E2E', 2, 'Application rejected by Enphase'],
    'Site_Submitted': ['Submitted for PSEG Review', '#F0D852', 4, 'Application submitted for PSEG Review'],
    'Site_Approved': ['Approved by PSEG', '#4ED01F', 5, 'Application approved by PSEG'],
    'Site_Rejected': ['Rejected by PSEG', '#FA2E2E', 4, 'Application rejected by PSEG'],
  },
  [FAMILY_KEY.CT_ESS]: {
    'Application_Submitted': ['Submitted for Enphase Review', '#F0D852', 1, 'Application submitted for Enphase Review', 1],
    'Application_Approved': ['Submitted for Utility Review', '#F0D852', 3, 'Application submitted for Utility Review', 3],
    'Application_Rejected': ['Rejected by Enphase', '#FA2E2E', 1, 'Application rejected by Enphase', 2],
    'Site_Submitted': ['Submitted for Utility Review', '#F0D852', 3, 'Application submitted for Utility Review', 3],
    'Site_Approved': ['Approved by Utility', '#4ED01F', 4, 'Application approved by Utility', 4],
    'Site_Rejected': ['Rejected by Utility', '#FA2E2E', 3, 'Application rejected by Utility', 4],
  }
}

const statusMapper = {
  [PROGRAM_KEY.APS_RBP]: {
    'All': '',
    'Submitted for APS Review': 'Application_Submitted',
    'Approved by APS': 'Application_Approved',
    'Rejected by APS': 'Application_Rejected',
    'Submitted for Enphase Review': 'Site_Submitted',
    'Approved by Enphase': 'Site_Approved',
    'Rejected by Enphase': 'Site_Rejected'
  },
  [PROGRAM_KEY.PSEG_LI]: {
    'All': '',
    'Submitted for Enphase Review': 'Application_Submitted',
    'Approved by Enphase': 'Application_Approved',
    'Rejected by Enphase': 'Application_Rejected',
    'Submitted for PSEG Review': 'Application_Approved',
    'Approved by PSEG': 'Site_Approved',
    'Rejected by PSEG': 'Site_Rejected',
  },
  [FAMILY_KEY.CT_ESS]: {
    'All': '',
    'Submitted for Enphase Review': 'Application_Submitted',
    'Approved by Enphase': 'Application_Approved',
    'Rejected by Enphase': 'Application_Rejected',
    'Submitted for Utility Review': 'Application_Approved',
    'Approved by Utility': 'Site_Approved',
    'Rejected by Utility': 'Site_Rejected',
  }
}

const getDropDownValues = (programKey) => {
  return programKey === PROGRAM_KEY.APS_RBP ? [ALL, SUBMITTEDFORAPS, APPROVEDBYAPS, REJECTEDBYAPS, SUBMITTEDFORENPHASE, APPROVEDBYENPHASE, REJECTEDBYENPHASE] :
    programKey === PROGRAM_KEY.PSEG_LI ? [ALL, SUBMITTEDFORENPHASE, REJECTEDBYENPHASE, SUBMITTEDFORPSEGREVIEW, APPROVEDBYPSEG, REJECTEDBYPSEG] :
      [ALL, SUBMITTEDFORENPHASE, REJECTEDBYENPHASE, SUBMITTEDFORUTILITYREVIEW, APPROVEDBYUTILITY, REJECTEDBYUTILITY]
}

const tableHeadings = (programKey, classes) => (
  programKey === PROGRAM_KEY.APS_RBP ?
    [{
      id: 'applicationId',
      header: 'APPLICATION ID',
      className: classes.centerAlign
    },
    {
      id: 'enphaseSiteId',
      header: 'ENPHASE SITE ID',
    },
    {
      id: 'homeOwnerName',
      header: 'HOME OWNER FULL NAME'
    },
    {
      id: 'installerName',
      header: 'INSTALLER NAME',
    },
    {
      id: 'applicationStatus',
      header: 'APPLICATION STATUS',
      isDropdown: true,
      dropDownValues: getDropDownValues(programKey)
    },
    ] :
    programKey === PROGRAM_KEY.PSEG_LI ? [
      {
        id: 'applicationId',
        header: 'APPLICATION ID',
        className: classes.centerAlign
      },
      {
        id: 'siteId',
        header: 'SITE ID',
      },
      {
        id: 'dlrpContractedAmount',
        header: 'DLRP CONTRACTED AMOUNT (kW)',
      },
      {
        id: 'homeOwnerName',
        header: 'HOME OWNER FULL NAME'
      },
      {
        id: 'applicationStatus',
        header: 'APPLICATION STATUS',
        isDropdown: true,
        dropDownValues: getDropDownValues(programKey)
      },
      {
        id: 'timeStamp',
        header: 'TIMESTAMP',
        className: classes.centerAlign,
        isPopover: true,
        popoverContent: 'This is the date and time when an application reaches a particular stage in the enrolment process'
      },
    ] : [
      {
        id: 'applicationId',
        header: 'APPLICATION ID',
        className: classes.centerAlign
      },
      {
        id: 'siteId',
        header: 'SITE ID',
      },
      {
        id: 'homeOwnerName',
        header: 'HOME OWNER FULL NAME'
      },
      {
        id: 'utility',
        header: 'UTILITY'
      },
      {
        id: 'committedCapacity',
        header: 'COMMITTED CAPACITY (kW)',
        className: classes.centerAlign
      },
      {
        id: 'applicationStatus',
        header: 'APPLICATION STATUS',
        isDropdown: true,
        dropDownValues: getDropDownValues(programKey)
      },
      {
        id: 'date',
        header: 'DATE',
        isPopover: true,
        popoverContent: 'This is the date and time when an application reaches a particular stage in the enrolment process'
      },
    ])

export {
  ALL,
  SUBMITTEDFORAPS,
  APPROVEDBYAPS,
  REJECTEDBYAPS,
  SUBMITTEDFORENPHASE,
  APPROVEDBYENPHASE,
  REJECTEDBYENPHASE,
  applicationStatus,
  tableApplicationStatus,
  statusMapper,
  tableHeadings
}